import { FC } from 'react';
import { BrandedUnifyWithIconIcon } from '../../icons/brandedIcons';

export const PageHeaderUnifyLogo: FC = () => <BrandedUnifyWithIconIcon style={{ height: '30px', width: '100px' }} />;
